import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";

interface OntarioObstetricalFileNoScreeningTestProps extends BaseOntarioObstetricalFileSubSectionProps {
    consultationDateAtStartOfObstetricalFile: Date;
}

class OntarioObstetricalFileNoScreeningTest extends BaseOntarioObstetricalFileSubSection<OntarioObstetricalFileNoScreeningTestProps, never> {
    public render(): JSX.Element {
        const noScreeningTest = this.props.form.Opr2.NoScreeningTest;

        return (
            <div className="section border border-bottom border-top">
                {this.renderSubTitle("ObstetricalFile_NoScreeningTestsLabel")}
                <div className="row row-form">
                    <div className="col-md-5 flex-display flex-align-items-center">
                        {this.controlRenderer.renderCheckbox(
                            "ObstetricalFile_CounseledAndDeclinedLabel",
                            noScreeningTest.IsCounseledAndDeclined,
                            value => this.props.mutateModelStateWithFormUpdate(s => {
                                s.Opr2.NoScreeningTest.IsCounseledAndDeclined = value;
                                if (value)
                                    s.Opr2.NoScreeningTest.CounseledAndDeclinedDate ||= this.props.consultationDateAtStartOfObstetricalFile;
                            }),
                            "margin-right-15px margin-top-5px",
                            "text-bold"
                        )}
                        <div className="flex-display flex-align-items-center">
                            <span className="margin-sm-right text-bold">{this.getString("DateLabel")}</span>
                            <span className="min-width-100px">
                                {this.controlRenderer.renderDateSelector({
                                    value: noScreeningTest.CounseledAndDeclinedDate,
                                    onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.NoScreeningTest.CounseledAndDeclinedDate = value),
                                    id: "CounseledAndDeclinedDate"
                                })}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-7 flex-display flex-align-items-center">
                        {this.controlRenderer.renderCheckbox(
                            "ObstetricalFile_PresentationGreaterThan20Plus6WeeksLabel",
                            noScreeningTest.IsPresented,
                            value => this.props.mutateModelStateWithFormUpdate(s => {
                                s.Opr2.NoScreeningTest.IsPresented = value;
                                if (value)
                                    s.Opr2.NoScreeningTest.OfferedNonInvasivePrenatalTestDate ||= this.props.consultationDateAtStartOfObstetricalFile;
                            }),
                            "margin-right-15px margin-top-5px",
                            "text-bold"
                        )}
                        <div className="flex-display flex-align-items-center">
                            <span className="margin-sm-right text-bold">{this.getString("ObstetricalFile_NoninvasivePrenatalTestingOfferedLabel")}</span>
                            {this.controlRenderer.renderInlineYesNoRadio(
                                noScreeningTest.IsOfferedNonInvasivePrenatalTest,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.NoScreeningTest.IsOfferedNonInvasivePrenatalTest = value),
                                "IsOfferedNonInvasivePrenatalTest",
                                "radio-btn-min-height margin-right-15px"
                            )}
                        </div>
                        <div className="flex-display flex-align-items-center">
                            <span className="margin-sm-right text-bold">{this.getString("DateLabel")}</span>
                            <span className="min-width-100px">
                                {this.controlRenderer.renderDateSelector({
                                    value: noScreeningTest.OfferedNonInvasivePrenatalTestDate,
                                    onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.NoScreeningTest.OfferedNonInvasivePrenatalTestDate = value),
                                    id: "OfferedNonInvasivePrenatalTestDate"
                                })}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFileNoScreeningTest };
